<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>I dedicate this, my latest book, to my newest grandchild RIVER REES (born 2018). I hope she enjoys reading this book, and she chooses to visit Aubusson herself, and finds her feet easily there because of her Nana’s and Denie’s experiences in 2008.</p>
<p>Nana Margaret</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?37340761